// src/components/config/Config.js
import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import './config.css';
import { AppContext } from '../../context/AppContext';
import Navbar from '../navbar/Navbar';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Config = () => {
  const [storeSetupCode, setStoreSetupCode] = useState('');
  const [deviceName, setDeviceName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { registerDevice } = useContext(AppContext);
  const navigate = useNavigate();

  // --------- Handlers ---------
  const handleStoreSetupCode = (e) => {
    setStoreSetupCode(e.target.value.trim());
  };

  const handleDeviceName = (e) => {
    const value = e.target.value.trim();
    const isValid = /^[a-zA-Z][a-zA-Z0-9]{0,19}$/.test(value);

    if (isValid) {
      setDeviceName(value);
      setError('');
    } else {
      setError('Must start with a letter, followed by up to 19 letters/numbers.');
    }
  };

  const showSuccessToast = (msg) => {
    toast.success(msg, { position: 'top-right', autoClose: 3000 });
  };

  const showErrorToast = (msg) => {
    toast.error(msg, { position: 'top-right', autoClose: 3000 });
  };

  const saveConfig = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!storeSetupCode) {
      showErrorToast('Please enter a store setup code');
      setLoading(false);
      return;
    }

    try {
      // Call unified registerDevice function from context
      const res = await registerDevice({ store_setup_code: storeSetupCode, device_name: deviceName });
      setLoading(false);

      if (res.status === 'success') {
        showSuccessToast(`Device registered to store successfully!`);
        setTimeout(() => navigate('/question1'), 2000);
      } else {
        showErrorToast(res.message || 'Failed to register device');
      }
    } catch (err) {
      console.error('saveConfig error:', err);
      setLoading(false);
      showErrorToast('Error registering device');
    }
  };

  const goToHome = () => {
    const deviceId = localStorage.getItem('device_id');
    const storeId = localStorage.getItem('store_id');

    if (deviceId && storeId && storeId !== 'null') {
      navigate('/question1');
      return;
    }

    localStorage.clear();
    navigate('/');
  };

  return (
    <>
      <Navbar />
      <div className='config-container'>
        <form className='config-form' onSubmit={saveConfig}>
          <label className='config-label'>*Store Setup Code</label>
          <input
            className='config-input'
            required
            type='text'
            placeholder='Enter store setup code'
            onChange={handleStoreSetupCode}
          />
          <br /><br />

          <label className='config-label'>Device Name</label>
          <input
            className='config-input'
            type='text'
            placeholder='Enter device name'
            onChange={handleDeviceName}
          />
          {error && <p style={{ color: 'red', fontSize: '12px' }}>{error}</p>}
          <br /><br />

          <button type='submit' className='config-button' disabled={loading}>
            {loading ? 'Registering...' : 'Register Device'}
          </button>
        </form>

        {loading && (
          <div className="spinner-container">
            <div className='config-loading-text'>Please wait while we register your device...</div>
          </div>
        )}

        <ToastContainer limit={2} />

        <div className='config-home-button-container'>
          <button 
            type='button'
            onClick={goToHome} 
            className='config-home-button'
            disabled={loading}
          >
            Home
          </button>
        </div>
      </div>
    </>
  );
};

export default Config;
